// Copyright (c) 2016 Deere & Company

import ConfirmationModal, {getDefaultState} from '../../../shared/state/confirmation-modal';
import actions from '../../../action-list';

const resetConfirmationModal = () => {

    document.body.classList.remove('warranty-modal-is-open');

    return getDefaultState();

};

const updateConfirmationModal = (state, action) => {

    document.body.classList.add('warranty-modal-is-open');

    return ConfirmationModal.update(state, {
        $set: action.data
    });

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_MAINTENANCE_PLAN_CONFIRMATION_MODAL]: resetConfirmationModal,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_CONFIRMATION_MODAL]: updateConfirmationModal
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/reducers/confirmation-modal.js